import { createUnifiedTheme, palettes } from '@backstage/theme';
import '../styles.css';

export const arlaTheme = (variant: string = 'light') => createUnifiedTheme({
  palette: {
    ...(variant === 'dark' ? palettes.dark : palettes.light),
    navigation: {
      ...(variant === 'dark' ? palettes.dark.navigation : palettes.light.navigation),
      background: 'var(--arla-sidebar-bg-color)',
    },
  },
});